/**
 * Audio store - manages microphone state and audio processing.
 * Uses platform-specific AudioProcessor and AudioPlayer.
 */

import { create } from "zustand";
import { AudioProcessor } from "../audio/AudioProcessor";
import { AudioPlayer } from "../audio/AudioPlayer";

interface AudioState {
  audioProcessor: AudioProcessor | null;
  audioPlayer: AudioPlayer | null;
  isStreaming: boolean;

  initAudio: () => Promise<void>;
  cleanUpAudio: () => void;
  setStreaming: (streaming: boolean) => void;
}

export const useAudioStore = create<AudioState>((set, get) => ({
  audioProcessor: null,
  audioPlayer: null,
  isStreaming: false,

  initAudio: async () => {
    const state = get();
    if (state.audioProcessor) return;

    const audioProcessor = new AudioProcessor();
    await audioProcessor.init();

    const audioPlayer = new AudioPlayer();
    await audioPlayer.init();

    set({ audioProcessor, audioPlayer });
  },

  cleanUpAudio: () => {
    const { audioProcessor, audioPlayer } = get();
    audioProcessor?.disconnect();
    audioPlayer?.stop();
    set({
      audioProcessor: null,
      audioPlayer: null,
      isStreaming: false,
    });
  },

  setStreaming: (isStreaming) => set({ isStreaming }),
}));
